import { render, staticRenderFns } from "./recupass.vue?vue&type=template&id=6f54d402"
import script from "./recupass.js?vue&type=script&lang=js&external"
export * from "./recupass.js?vue&type=script&lang=js&external"
import style0 from "./recupass.vue?vue&type=style&index=0&id=6f54d402&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports